import Point from '../../../Utility/Point';
import Sprite from '../../Sprite';

export default class BullsEye extends Sprite {
    public create(params: any): void {
        super.create({
            name: 'bullsEyeSprite',
            texture: 'bullseye_asset',
            anchor: new Point(0.5, 0.5),
        });
    }
}
